import React, {useState, useEffect} from 'react';

import { useOutletContext } from 'react-router-dom';
import { useAuthContext } from '../../context/Auth';
import { useUserList, useDeleteUserMutation, useUserEdit} from '../../hooks/useUser';

import {Typography, FormControl, OutlinedInput, InputAdornment,IconButton,Collapse} from '@mui/material';

import 'simplebar-react/dist/simplebar.min.css';
import '../settings_comp/settings_styles.scss';


import ButtonImg from '../button/Btn_img';
import UserAddModal from '../modal/Modal_add_user';
import DeleteV2Modal from '../modal/Modal_delete_V2';
import SklInput from '../skeletons/Skl_input';
import SimpleBar from 'simplebar-react';
import Grid from '@mui/material/Unstable_Grid2';
import { createSvgIcon } from '@mui/material/utils';
import AddUserIcon from '../../assets/profile-add.svg'
import SearchIcon from '../../assets/search.svg';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import infoIcon from '../../assets/info-circle-guide.svg';
import CloseOutlineIcon from '../../assets/info-circle-outline-guide.svg'
import CloseIcon from '../../assets/Close-guide-icon.svg'
import ActivityTable from './ActivityTable';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';

const ActivityLogs = () =>{

    const {triggerAlert} = useOutletContext(); 
    const [openAddUser, setOpenAddUser] = useState(false);
    const [editId, setEditId] = useState(0)
    const [userId, setUserId] = useState(0)
    const [openDelete, setOpenDelete] = useState(false);
    const [delText, setDelText] = useState('user')
    const {tokenReview, popupAction} = useAuthContext()
    const [btnLoading, setBtnLoading] = useState(false);
   
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState("");
    // const {data: userListData, isLoading: userListLoading, isSuccess: userListSuccess, isError: userListError, error: userListErrorMsg } = useUserList(debouncedSearch ?? "");
    
    const [guideUsr, setGuideUsr] = useState(false);
   const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const CalendarSvgIconxx = createSvgIcon(
        <svg id="vuesax_linear_calendar-2" data-name="vuesax/linear/calendar-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g id="calendar-2">
                <path id="Vector" d="M0,0V3" transform="translate(8 2)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-2" data-name="Vector" d="M0,0V3" transform="translate(16 2)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-3" data-name="Vector" d="M0,0H17" transform="translate(3.5 9.09)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-4" data-name="Vector" d="M18,5v8.5c0,3-1.5,5-5,5H5c-3.5,0-5-2-5-5V5C0,2,1.5,0,5,0h8C16.5,0,18,2,18,5Z" transform="translate(3 3.5)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                <path id="Vector-6" data-name="Vector" d="M.495.5H.5" transform="translate(11.501 13.2)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-7" data-name="Vector" d="M.495.5H.5" transform="translate(7.8 13.2)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <path id="Vector-8" data-name="Vector" d="M.495.5H.5" transform="translate(7.8 16.2)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            </g>
        </svg>
    );
    //API error handling

  

 

    
    return(
        <>
            
            
            <SimpleBar className='min-h-setting-report pr-5'>
            <div className='flex justify-between items-center mb-5'>
  {/* Left Section: Users Title */}
  <Typography variant="text32" component="div">
    Activity logs
    <IconButton className="ml-1" aria-label="close" onClick={() => setGuideUsr(true)}>
      <img src={CloseOutlineIcon} alt="close" />
    </IconButton>
  </Typography>

  {/* Right Section: Filters */}
  <Grid container spacing={2} alignItems="center">
  {/* Start Date */}
  <Grid xs={12} md={4}>
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          value={moment.isMoment(startDate) ? startDate : null}
          onChange={(newValue) => setStartDate(newValue)}
          slots={{ openPickerIcon: CalendarSvgIconxx }}
          maxDate={moment()}
          minDate={moment('2024-01-04')}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: 'Start date',
              InputProps: {
                sx: { height: 48 },
              },
              sx: { height: 48 }, // this ensures the full TextField height
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  </Grid>

  {/* End Date */}
  <Grid xs={12} md={4}>
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          value={moment.isMoment(endDate) ? endDate : null}
          onChange={(newValue) => setEndDate(newValue)}
          slots={{ openPickerIcon: CalendarSvgIconxx }}
          minDate={startDate ?? moment('2024-01-04')}
          maxDate={moment()}
          disabled={!startDate}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: 'End date',
              InputProps: {
                sx: { height: 48 },
              },
              sx: { height: 48 },
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  </Grid>

  {/* Search Input */}
  <Grid xs={12} md={4}>
    <FormControl fullWidth>
      <OutlinedInput
        className="search-input rounded-xl"
        autoComplete="off"
        placeholder="Search"
        type="text"
        value={searchTerm}
        sx={{ height: 48 }} // same height as DatePickers
        startAdornment={
          <InputAdornment position="start">
            <img src={SearchIcon} alt="icon" className="w-5" />
          </InputAdornment>
        }
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </FormControl>
  </Grid>
</Grid>

</div>

            <Collapse in={guideUsr} className="overflow-hidden">
                <div className='mb-5'>
                    <div className='bg-waterBlue py-4 px-5 rounded-xl font-sans flex justify-between items-center relative'>
                        <div className='flex items-start w-full'>
                            <img src={infoIcon} alt='info' className='w-6 h-6 mr-5'/>
                            <div className='text-midnightGreen text-base font-sans w-[calc(100%-6rem)] pr-3'>
                                <div className='font-base font-semibold uppercase'>Information:</div>
                                <div className='font-medium'>
                                    Track and monitor all administrative actions performed within the platform, including document uploads,deletions, approvals, rejections, and reprocessing.This log provides a transparent audit tail to ensure accountability and and system integrity 
                                </div>
                            </div>
                            
                            <IconButton className='text-white absolute top-2 right-3'
                                aria-label="close"
                                onClick={() => setGuideUsr(false)}
                            >
                                <img src={CloseIcon} alt='close'/>
                            </IconButton>
                        </div>
                    </div>
                </div>
             </Collapse>

            <div>
                <ActivityTable
                    searchTerm={searchTerm} 
                    dateFrom={startDate} 
                    dateTo={endDate} 
                    
                />
            </div>
            </SimpleBar>
            
           
        </>
    )
}

export default ActivityLogs;
